<template>
  <div class="mt-6 w-full space-y-1">
    <div
      v-for="(usp, index) in usps"
      :key="`usp_${index}`"
      class="flex w-full items-start gap-1"
    >
      <CheckIcon
        class="not-sr-only h-6 w-6 shrink-0 stroke-[2.5px] text-tertiary"
      />
      <span class="usp-item" v-html="usp" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/20/solid';
import { computed, ComputedRef } from 'vue';

const usps: ComputedRef<string[]> = computed(() => window.usps);
</script>

<style>
.usp-item a {
  color: theme('colors.blue.darkest');

  &:hover {
    text-decoration: underline;
  }
}
</style>
